/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {logWarning} from "App/debug";
import Canvas from "App/canvas";

export default
class Canvas2DContext {
    private ctx2d: CanvasRenderingContext2D|null = null;
    private _canvas: Canvas;

    private _isValid: boolean;

    constructor(aCanvas: Canvas) {
        this._canvas = aCanvas;
        this._isValid = this.setupContext();
    }

    private setupContext(): boolean {
        let validContextNames = ['2d'];

        for (let i = 0; i < validContextNames.length; i++) {
            try {
                let ctx: any = this._canvas.getHTML2DOverlayCanvas().getContext(validContextNames[i]);
                if (ctx) {
                    ctx.ext = {};
                    this.ctx2d = ctx;
                    return true;
                }
            }
            catch (e) {
                logWarning(e);
            }
        }

        return false;
    }

    public getRenderingContext(): CanvasRenderingContext2D|null {
        return this.ctx2d;
    }

    public getCanvas(): Canvas {
        return this._canvas;
    }

    public isValid(): boolean {
        return this._isValid;
    }

    public release() {
    }
}
